export default __webpack_public_path__ + "static/media/16.fcfbcae3.jpg";